import { FeatureFlagService } from "@fxp/flightingsdk";
import { Constants } from "../../common/constants";
import { appSettings } from '../../environments/common/appsettingsGenerator';
import { UserInfoService } from '@fxp/fxpservices';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
interface IFlightingService {
  evaluateFeatureFlag: (
        featureFlags: string[]
    ) => Promise<any>; 
}
export class FlightingService implements IFlightingService {
    private static instance: FlightingService;
    private featureFlagService: FeatureFlagService;
    private userInfoService: UserInfoService;
    private environmentConfig = appSettings();

    private constructor() {
        this.featureFlagService = FxpServiceFactory.getServiceInstance(
            FXPServiceCatalog.FeatureFlagService
        );
        this.userInfoService = FxpServiceFactory.getServiceInstance(
            FXPServiceCatalog.UserInfoService
          );
    }

    public static getInstance(): FlightingService {
        if (!FlightingService.instance) {
            FlightingService.instance = new FlightingService();
        }
        return FlightingService.instance;
    }

    public async evaluateFeatureFlag(featureFlags: string[]): Promise<any> {
        try {
            const contextProperties = { "UserUPN": this.userInfoService.getCurrentUserUpn() };
            return await this.featureFlagService.getFeatureFlags(
              Constants.FlightingConstants.ApplicationName,
              this.environmentConfig.flightingAppEnvironment,
              featureFlags,
              contextProperties
            );
          } catch (error) {
            // Return an object with all requested flags set to false
            const flagsResponse = featureFlags.reduce((acc, flag) => {
                acc[flag] = false;
                return acc;
            }, {} as Record<string, boolean>);
            return flagsResponse;
        }
    }
}